import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { bookCall } from "./Hero";

const LINKS = [
    { label: "Work", href: "#work" },
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "Gallery", href: "#gallery" },
    { label: "Contact", href: "#contact" },
];

export const Nav = () => {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="site-nav"
            className="fixed top-0 inset-x-0 z-50 bg-[#0C0C0C]/90 backdrop-blur-xl border-b border-[#262626]"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 h-16 md:h-20 flex items-center justify-between">
                <Logo />
                <nav className="hidden md:flex items-center gap-9">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="link-underline text-sm font-medium text-[#A9A6A0] hover:text-[#F1F1EF] transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <a
                        href="tel:+14175904345"
                        data-testid="nav-call-btn"
                        className="hidden lg:inline-flex items-center gap-2 text-sm font-semibold text-[#CFCCC6] hover:text-[#F1F1EF] transition-colors duration-300"
                    >
                        <Phone size={15} />
                        (417) 590-4345
                    </a>
                    <a
                        href="#contact"
                        onClick={bookCall}
                        data-testid="nav-book-call-btn"
                        className="hidden md:inline-flex items-center gap-1.5 bg-[#D3A0A7] text-[#0C0C0C] text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-[#F1F1EF] transition-colors duration-300"
                    >
                        Book a Call
                        <ArrowUpRight size={15} />
                    </a>
                    <button
                        data-testid="nav-mobile-toggle"
                        onClick={() => setOpen(!open)}
                        className="md:hidden p-2 text-[#F1F1EF]"
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>
            <AnimatePresence>
                {open && (
                    <motion.nav
                        data-testid="nav-mobile-menu"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="md:hidden overflow-hidden bg-[#0C0C0C] border-t border-[#262626]"
                    >
                        <div className="px-6 py-6 flex flex-col gap-5">
                            {LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                    onClick={() => setOpen(false)}
                                    className="font-serif-ed text-2xl text-[#F1F1EF]"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href="tel:+14175904345"
                                data-testid="nav-mobile-call-btn"
                                onClick={() => setOpen(false)}
                                className="inline-flex w-fit items-center gap-2 border border-[#CFCCC6]/40 text-[#CFCCC6] text-sm font-semibold px-5 py-2.5 rounded-full"
                            >
                                <Phone size={15} /> Call (417) 590-4345
                            </a>
                            <a
                                href="#contact"
                                data-testid="nav-mobile-book-call-btn"
                                onClick={() => {
                                    setOpen(false);
                                    bookCall();
                                }}
                                className="inline-flex w-fit items-center gap-1.5 bg-[#D3A0A7] text-[#0C0C0C] text-sm font-semibold px-5 py-2.5 rounded-full"
                            >
                                Book a Call <ArrowUpRight size={15} />
                            </a>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
};
